import { render } from "./BotonGuardias.vue?vue&type=template&id=58fd4b8e&scoped=true"
import script from "./BotonGuardias.vue?vue&type=script&lang=js"
export * from "./BotonGuardias.vue?vue&type=script&lang=js"

import "./BotonGuardias.vue?vue&type=style&index=0&id=58fd4b8e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fd4b8e"]])

export default __exports__